export default "__VITE_ASSET__DkYTSORP__"